import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ExifodSectionV2 = () => {
  const [sections, setSections] = useState([]);
  const publicUrl = process.env.PUBLIC_URL + '/';
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    axios
      .get(`${Url}/api/ExifodSection/all`)
      .then((res) => {
        if (res.data && res.data.data) {
          setSections(res.data.data.filter((item) => item.isDeleted === 0));
        }
      })
      .catch((err) => {
        console.error(
          'Erreur lors de la récupération des sections EXIFOD :',
          err,
        );
      });
  }, []);

  return (
    <div style={{ backgroundColor: '#f8f8f8' }}>
      <div className="exifod-container">
        <div className="row">
          {sections.map((section) => (
            <div
              className="col-lg-6 col-md-12 mt-4 mb-4"
              key={section.sectionId}
            >
              <div className="single-intro-inner style-icon-bg text-start">
                <div className="details">
                  <h4 className="mb-3">{section.sectionTitre}</h4>
                  <p
                    style={{
                      whiteSpace: 'pre-line',
                      textAlign: 'justify',
                    }}
                  >
                    {section.sectionDescription}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ExifodSectionV2;
